import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const RMWIcon = (props) => {
  return (
    <SvgIcon width={22} height={22} viewBox="0 0 600 600" {...props}>

<path d="M195.607,226.063l39.777,10.658l-26.518,0.019c37.883,33.406,66.295,0,66.295,0
	C244.855,211.427,195.607,226.063,195.607,226.063z"/>
<path d="M367.976,236.739l-26.519-0.019l39.778-10.658c0,0-49.249-14.636-79.556,10.677
	C301.68,236.739,330.093,270.146,367.976,236.739z"/>
<g>
	<path d="M302.682,342.705c-3.734-4.975-7.53-9.562-11.321-13.667c-3.851,4.154-7.679,8.733-11.417,13.662
		C287.52,342.346,295.106,342.347,302.682,342.705z"/>
	<path d="M330.813,391.038c-1.784,3.439-3.644,6.838-5.578,10.193c-1.904,3.302-3.873,6.566-5.906,9.79
		c6.345-0.762,12.367-1.786,17.944-3.06C335.553,402.57,333.386,396.899,330.813,391.038z"/>
	<path d="M273.85,412.086c5.609,0.362,11.433,0.55,17.419,0.55c6.011,0,11.91-0.211,17.616-0.619
		c3.238-4.861,6.316-9.827,9.231-14.891c2.939-5.091,5.696-10.285,8.267-15.572c-2.597-5.234-5.362-10.382-8.295-15.437
		c-2.914-5.04-6.005-9.978-9.269-14.8c-5.72-0.436-11.594-0.664-17.55-0.664c-5.93,0-11.797,0.226-17.519,0.658
		c-3.296,4.83-6.408,9.785-9.328,14.851v-0.001c-2.921,5.065-5.651,10.238-8.183,15.509c2.539,5.27,5.276,10.44,8.208,15.502
		C267.393,402.26,270.529,407.234,273.85,412.086z M291.268,364.294c9.489,0,17.181,7.691,17.181,17.179
		c0,9.488-7.691,17.179-17.181,17.179c-9.486,0-17.179-7.69-17.179-17.179C274.089,371.985,281.781,364.294,291.268,364.294z"/>
	<path d="M319.352,352.379c2.019,3.165,3.97,6.372,5.85,9.622c1.911,3.299,3.757,6.636,5.535,10.01
		c2.432-5.696,4.499-11.252,6.156-16.566C331.37,354.184,325.49,353.154,319.352,352.379z"/>
	<path d="M263.199,352.364c-6.098,0.761-11.951,1.766-17.441,2.993c1.672,5.391,3.72,10.971,6.113,16.647
		c1.733-3.358,3.544-6.675,5.431-9.948C259.191,358.779,261.158,355.547,263.199,352.364z"/>
	<path d="M339.104,347.521c0.312-1.27,0.6-2.544,0.865-3.824c4.047-19.648,1.541-34.631-4.899-38.346
		c-6.05-3.489-19.323,1.392-33.526,13.753c-1.509,1.314-2.983,2.668-4.425,4.057c5.498,5.925,10.976,12.77,16.262,20.297
		C322.455,344.309,331.123,345.679,339.104,347.521z"/>
	<path d="M263.375,411.168c-2.091-3.245-4.105-6.539-6.04-9.88c-1.896-3.274-3.714-6.594-5.454-9.954
		c-2.445,5.798-4.537,11.499-6.235,16.983C251.132,409.513,257.075,410.465,263.375,411.168z"/>
	<path d="M350.58,359.302c-1.842-0.634-3.752-1.234-5.719-1.805c-2.367,7.658-5.526,15.749-9.362,24.017
		c4.019,8.467,7.306,16.664,9.741,24.371c1.1-0.325,2.18-0.662,3.23-1.01h0.001c19.042-6.311,30.77-15.965,30.77-23.402
		C379.241,374.49,368.383,365.429,350.58,359.302z"/>
	<path d="M243.539,347.436c7.962-1.804,16.624-3.151,25.671-3.989c5.277-7.447,10.799-14.279,16.389-20.28
		c-0.965-0.923-1.928-1.814-2.887-2.666c-15.001-13.319-29.232-18.632-35.669-14.905c-6.042,3.497-8.443,17.436-4.827,35.914
		C242.607,343.494,243.048,345.471,243.539,347.436z"/>
	<path d="M291.269,420.853c-3.817,0-7.573-0.073-11.256-0.218c3.795,5.001,7.68,9.649,11.575,13.853
		c3.765-4.145,7.547-8.8,11.294-13.892C299.065,420.766,295.19,420.853,291.269,420.853z"/>
	<path d="M527.504,143.86H354.376l92.748-7.344c-12.368-73.872-90.688-125.468-90.688-125.468
		c-40.077-35.281-68.016,25.212-68.016,25.212s-27.937-60.493-68.016-25.212c0,0-72.137,51.596-84.503,125.468l86.565,7.344H49.338
		c0,0-76.259,0-39.162,77.661l144.274,42.434v116.676c0,0,0,54.931,133.97,130.697c133.97-75.767,133.97-130.697,133.97-130.697
		V263.955l144.274-42.434C603.762,143.86,527.504,143.86,527.504,143.86z M351.057,412.675c-1.166,0.388-2.361,0.758-3.579,1.117
		c0.435,1.748,0.822,3.464,1.154,5.143c4.354,21.993,1.001,40.069-9.318,46.044c-9.99,5.783-26.14,0.102-42.49-13.968
		c-1.776-1.533-3.511-3.115-5.2-4.745c-1.34,1.297-2.68,2.534-4.015,3.7c-16.88,14.756-34.214,20.876-44.543,14.921
		c-10-5.769-13.142-22.595-9.118-43.787c0.44-2.303,0.944-4.593,1.511-6.868c-1.748-0.498-3.482-1.041-5.202-1.626
		c-21.216-7.251-35.179-19.209-35.179-31.133c0-11.543,13.008-22.673,33.376-29.774c2.276-0.793,4.656-1.539,7.12-2.239
		c-0.527-2.111-1.001-4.235-1.422-6.371c-4.22-21.567-1.25-38.802,8.775-44.605c10.457-6.054,27.871,0.445,45.244,15.872
		c1.08,0.962,2.144,1.943,3.188,2.944c1.56-1.506,3.157-2.971,4.79-4.396c16.577-14.427,32.991-20.461,43.026-14.672
		c10.467,6.034,13.532,24.367,8.845,47.122c-0.293,1.415-0.612,2.823-0.957,4.225c2.081,0.6,4.146,1.25,6.193,1.951
		c20.778,7.153,34.204,18.358,34.204,29.943C387.459,393.555,373.111,405.368,351.057,412.675z M401.778,285.923l-113.357-30.259
		l-113.357,30.259v-62.508c0,0,61.83-22.833,113.357-18.046c51.527-4.788,113.357,18.046,113.357,18.046V285.923z"/>
	<path d="M339.528,415.878c-7.969,1.841-16.755,3.19-26.056,4.017c-5.287,7.653-10.705,14.547-16.126,20.477
		c1.619,1.558,3.234,3.03,4.838,4.409c13.981,12.032,26.948,16.595,33.011,13.084c2.85-1.647,5.153-5.766,6.299-11.941
		c1.276-6.873,1-15.666-0.924-25.392C340.269,419.013,339.92,417.462,339.528,415.878z"/>
	<path d="M237.78,357.375c-2.227,0.631-4.435,1.325-6.622,2.085c-17.419,6.072-27.864,15.008-27.864,22.013
		c0,3.293,2.411,7.35,7.181,11.437c5.311,4.546,13.058,8.713,22.438,11.92c1.571,0.533,3.154,1.029,4.75,1.486
		c2.43-7.922,5.632-16.24,9.493-24.643C243.346,373.395,240.188,365.206,237.78,357.375z"/>
	<path d="M243.426,416.245c-0.527,2.115-0.996,4.246-1.405,6.388c-3.44,18.122-0.919,31.634,5.15,35.134
		c2.852,1.645,7.57,1.584,13.493-0.508h0.001c6.592-2.328,14.071-6.957,21.536-13.481c1.249-1.095,2.471-2.222,3.665-3.376
		c-5.618-6.028-11.192-12.913-16.514-20.403C260.029,419.242,251.306,417.988,243.426,416.245z"/>
</g>


    </SvgIcon>
  );
}

export default RMWIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/RMWIcon.js